export default __webpack_public_path__ + "static/media/flag-de.0d448ed0.svg";